import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./yearpicker.css";
import { FiChevronDown } from "react-icons/fi";

// Custom input button
const CustomInput = forwardRef(({ value, onClick }, ref) => (
  <button type="button" className="custom-year-picker-btn" onClick={onClick} ref={ref}>
    {value || "Select Year"}
    <FiChevronDown className="custom-year-icon" />
  </button>
));

const YearPicker = ({ selectedYear, setSelectedYear }) => {
  return (
    <div className="year-picker-container">
      <DatePicker selected={selectedYear} onChange={(date) => setSelectedYear(date)} showYearPicker dateFormat="yyyy" customInput={<CustomInput />} />
    </div>
  );
};

export default YearPicker;
